import React from "react";
import { Button } from "semantic-ui-react";
import "../Events.css";

const StoWFilter = (props) => {
  return (
    <>
      <div className="AthleteSearchBanner main-filter-event testimonial-title media-tite">
        <h1>Media</h1>
        <div className="btn-data with-flex j-center small-mb">
          {props.reorder ? (
            <>
              <Button
                icon="check"
                labelPosition="left"
                color="green"
                name="saveButton"
                content="Save"
                onClick={props.handleReorderSave}
              />
              <Button
                className="d-small-hidden"
                icon="close"
                labelPosition="left"
                color="red"
                name="AddRearrange"
                content="Close"
                onClick={() => props.handleReorder(false)}
              />
            </>
          ) : (
            <>
              <Button
                className="d-small-hidden"
                icon="sort numeric up"
                labelPosition="left"
                color="blue"
                name="AddRearrange"
                content="Rearrange"
                onClick={() => props.handleReorder(true)}
              />

              <Button
                icon="plus"
                labelPosition="left"
                color="teal"
                name="AddSkillButton"
                content="Add"
                onClick={props.handleAdd}
              />
            </>
          )}
        </div>
        <div className="AthleteSearchFilterContainer"></div>
      </div>
    </>
  );
};

export default StoWFilter;
